"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VizzlyApi = void 0;
const Api_1 = require("./Api");
const errors_1 = require("../errors");
const FailedToFetchVizzlyConfig_1 = require("../errors/FailedToFetchVizzlyConfig");
const ConnectionDoesNotExistOnProject_1 = require("../errors/ConnectionDoesNotExistOnProject");
const FailedToFetchConnection_1 = require("../errors/FailedToFetchConnection");
const FailedToFetchProject_1 = require("../errors/FailedToFetchProject");
const FailedToUpdateQueryEngineUser_1 = require("../errors/FailedToUpdateQueryEngineUser");
const FailedToSaveProjectEncryptedEncryptionSecret_1 = require("../errors/FailedToSaveProjectEncryptedEncryptionSecret");
const ProjectEncryptedSecretAlreadySaved_1 = require("../errors/ProjectEncryptedSecretAlreadySaved");
class VizzlyApi extends Api_1.Api {
    constructor(auth, host = 'https://api.vizzly.co') {
        super(auth, host);
    }
    buildFetchDashboardAccessTokensRequest(params) {
        return {
            path: '/api/v2/auth/dashboards/access',
            method: 'post',
            body: {
                dashboardAccessToken: this.auth.getDashboardAccessToken(),
                projectAdminOverrideToken: this.auth.getProjectAdminOverrideToken(),
            },
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
        };
    }
    fetchGlobalLibraries(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildFetchGlobalLibrariesRequest(params));
        });
    }
    buildFetchGlobalLibrariesRequest(params) {
        return {
            path: '/api/v2/multi-get-global-library',
            method: 'post',
            body: {
                globalLibraryAccessTokens: params.globalLibraryAccessTokens,
            },
            abortSignal: params.abortSignal,
        };
    }
    fetchGlobalLibraryAccessTokens(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildFetchGlobalLibraryAccessTokensRequest(params));
        });
    }
    buildFetchGlobalLibraryAccessTokensRequest(params) {
        return {
            path: '/api/v2/auth/global-library/access',
            method: 'post',
            body: {
                dashboardAccessToken: this.auth.getDashboardAccessToken(),
                projectAdminOverrideToken: this.auth.getProjectAdminOverrideToken(),
            },
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
        };
    }
    buildCreateDashboardRequest(params) {
        return {
            path: '/api/v2/dashboard',
            method: 'post',
            body: {
                dashboardAccessToken: this.auth.getDashboardAccessToken(),
                definition: params.definition,
                meta: params.metadata || params.meta || {},
                parentDashboardId: params.parentDashboardId,
                permissions: params.permissions,
            },
            abortSignal: params.abortSignal,
        };
    }
    buildFetchDashboardsRequest(params) {
        return {
            path: '/api/v2/multi-get-dashboard',
            method: 'post',
            body: {
                dashboardAccessTokens: params.dashboardSessionAccessTokens,
            },
            abortSignal: params.abortSignal,
        };
    }
    createParentDashboard(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildCreateParentDashboardRequest(params));
        });
    }
    buildCreateParentDashboardRequest(params) {
        return {
            path: '/api/v2/parent-dashboard',
            method: 'post',
            body: {
                projectId: params.projectId,
                definition: params.definition,
            },
            abortSignal: params.abortSignal,
        };
    }
    createParentGlobalLibrary(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildCreateParentGlobalLibraryRequest(params));
        });
    }
    buildCreateParentGlobalLibraryRequest(params) {
        return {
            path: '/api/v2/parent-global-library',
            method: 'post',
            body: {
                projectId: params.projectId,
                library: params.library,
            },
            abortSignal: params.abortSignal,
        };
    }
    createGlobalLibrary(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const result = yield this.execute(this.buildCreateGlobalLibraryRequest(params));
            if (result.status === 200)
                return result.body;
            throw new errors_1.FailedToCreateGlobalLibrary('Failed to create global library');
        });
    }
    buildCreateGlobalLibraryRequest(params) {
        return {
            path: '/api/v2/global-library',
            method: 'post',
            body: {
                dashboardAccessToken: this.auth.getDashboardAccessToken(),
                parentGlobalLibraryId: params.parentGlobalLibraryId,
                library: params.library,
                permissions: params.permissions,
            },
            abortSignal: params.abortSignal,
        };
    }
    getProjects(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.execute(this.buildGetProjectsRequest(params));
            if (response.status === 200)
                return { projects: response.body.projects };
            throw new errors_1.FailedToFetchProjects(`Failed to fetch projects. Got status ${response.status}`);
        });
    }
    buildGetProjectsRequest(params) {
        return {
            path: `/api/v2/projects`,
            method: 'get',
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
        };
    }
    createProjectApiKey(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildCreateProjectApiKeyRequest(params));
        });
    }
    buildCreateProjectApiKeyRequest(params) {
        return {
            path: `/api/v3/project/${params.projectId}/api-key`,
            method: 'post',
            body: {},
            abortSignal: params.abortSignal,
        };
    }
    createQueryEngineUser(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.execute(this.buildCreateQueryEngineUserRequest(params));
            if (response.status === 200)
                return response.body.query_engine_user;
            throw new errors_1.FailedToCreateQueryEngineUser(`Failed to create query engine user. Got status ${response.status}`);
        });
    }
    buildCreateQueryEngineUserRequest(params) {
        return {
            path: `/api/v3/project/${params.projectId}/query-engine-user`,
            method: 'post',
            body: {
                email: params.email,
                password: params.password,
            },
            abortSignal: params.abortSignal,
        };
    }
    buildCreateSelfHostedDynamicQueryEngineProjectRequest(params) {
        return {
            path: `/api/v2/project/self-hosted-dynamic-query-engine`,
            method: 'post',
            body: {},
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
        };
    }
    buildCreateSelfHostedInBrowserProjectRequest(params) {
        return {
            path: `/api/v2/project/self-hosted-in-browser`,
            method: 'post',
            body: {},
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
        };
    }
    buildCreateSelfHostedProjectRequest(params) {
        return {
            path: `/api/v2/project/self-hosted-query-engine`,
            method: 'post',
            body: {},
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
        };
    }
    createManagedQueryEngineProject(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildCreateManagedQueryEngineProjectRequest(params));
        });
    }
    buildCreateManagedQueryEngineProjectRequest(params) {
        return {
            path: `/api/v2/project/managed-query-engine`,
            method: 'post',
            body: {
                parent_dashboard_definition: {},
            },
            abortSignal: params === null || params === void 0 ? void 0 : params.abortSignal,
        };
    }
    createVizzlyConfigVersion(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildCreateVizzlyConfigVersionRequest(params));
        });
    }
    buildCreateVizzlyConfigVersionRequest(params) {
        return {
            path: `/api/v3/project/${params.projectId}/config`,
            method: 'post',
            body: {
                projectId: params.projectId,
                encryptedConfig: params.encryptedConfig,
            },
            abortSignal: params.abortSignal,
        };
    }
    duplicateParentDashboard(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildDuplicateParentDashboardRequest(params));
        });
    }
    buildDuplicateParentDashboardRequest(params) {
        return {
            path: `/api/v2/duplicate-parent-dashboard`,
            method: 'post',
            body: {
                dashboardId: params.dashboardId,
            },
            abortSignal: params.abortSignal,
        };
    }
    getConnection(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.execute(this.buildGetConnectionRequest(params));
            if (response.status === 200) {
                return {
                    encryptedCredentials: response.body.encrypted_credentials,
                };
            }
            if (response.status == 404) {
                throw new ConnectionDoesNotExistOnProject_1.ConnectionDoesNotExistOnProject('An active connection does not exist on the project');
            }
            throw new FailedToFetchConnection_1.FailedToFetchConnection(`Failed to fetch connection for the project. Got status ${response.status}`);
        });
    }
    buildGetConnectionRequest(params) {
        return {
            path: `/api/v2/project/${params.projectId}/connection`,
            method: 'get',
            abortSignal: params.abortSignal,
            acceptedAuthParams: ['projectApiKey', 'projectAccessToken'],
        };
    }
    getManagedQueryEngineKeyPair(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildGetManagedQueryEngineKeyPairRequest(params));
        });
    }
    buildGetManagedQueryEngineKeyPairRequest(params) {
        return {
            path: `/api/v2/project/managed-query-engine/${params.managedProjectId}/key-pairs/${params.keyPairId}`,
            method: 'get',
            abortSignal: params.abortSignal,
        };
    }
    getProject(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const getProjectResponse = yield this.execute(this.buildGetProjectRequest(params));
            if (getProjectResponse.status === 200)
                return getProjectResponse.body;
            throw new FailedToFetchProject_1.FailedToFetchProject(`Failed to fetch project. Got status ${getProjectResponse.status}`);
        });
    }
    buildGetProjectRequest(params) {
        return {
            path: `/api/v3/project/${params.projectId}`,
            method: 'get',
            abortSignal: params.abortSignal,
            acceptedAuthParams: ['projectApiKey', 'projectAccessToken', 'appSessionToken'],
        };
    }
    getProjectAccessToken(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildGetProjectAccessTokenRequest(params));
        });
    }
    buildGetProjectAccessTokenRequest(params) {
        let filterString = '';
        if (params.resourceFilters)
            filterString = `filter=${params.resourceFilters.join(',')}`;
        return {
            path: `/api/v2/auth/project/${params.projectId}/access_token?${filterString}`,
            method: 'get',
            abortSignal: params.abortSignal,
            acceptedAuthParams: ['projectApiKey', 'appSessionToken'],
        };
    }
    getQueryEngineUser(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.execute(this.buildGetQueryEngineUserRequest(params));
            if (response.status === 200)
                return response.body.query_engine_user;
            throw new errors_1.FailedToFetchQueryEngineUser(`Failed to fetch query engine user. Got status ${response.status}`);
        });
    }
    buildGetQueryEngineUserRequest(params) {
        return {
            path: `/api/v3/project/${params.projectId}/query-engine-user?email=${encodeURIComponent(params.email)}`,
            method: 'get',
            abortSignal: params.abortSignal,
            acceptedAuthParams: ['projectApiKey', 'projectAccessToken'],
        };
    }
    getTeamMembers(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.execute(this.buildGetTeamMembersRequest(params));
            if (response.status === 200)
                return response.body;
            throw new errors_1.FailedToFetchTeamMembers(`Failed to fetch team members. Got status ${response.status}`);
        });
    }
    buildGetTeamMembersRequest(params) {
        return {
            path: `/api/v3/project/${params.projectId}/organisation-team-members`,
            method: 'get',
            abortSignal: params.abortSignal,
            acceptedAuthParams: ['projectApiKey', 'projectAccessToken'],
        };
    }
    getVizzlyConfig(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.execute(this.buildGetVizzlyConfigRequest(params));
            if (response.status === 200) {
                return {
                    encryptedConfig: response.body.encrypted_config,
                };
            }
            throw new FailedToFetchVizzlyConfig_1.FailedToFetchVizzlyConfig(`Failed to fetch the config containing data sets from the Vizzly API. Got status ${response.status}`);
        });
    }
    buildGetVizzlyConfigRequest(params) {
        return {
            path: `/api/v3/project/${params.projectId}/config`,
            method: 'get',
            abortSignal: params.abortSignal,
            acceptedAuthParams: ['projectApiKey', 'projectAccessToken'],
        };
    }
    saveConnection(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildSaveConnectionRequest(params));
        });
    }
    buildSaveConnectionRequest(params) {
        return {
            path: `/api/v3/project/connection`,
            method: 'post',
            body: {
                projectId: params.projectId,
                encryptedConfig: params.encryptedConfig,
                encryptedConnection: params.encryptedConnection,
            },
            abortSignal: params.abortSignal,
            acceptedAuthParams: ['projectApiKey', 'projectAccessToken'],
        };
    }
    saveEncryptedProjectEncryptionSecret(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.execute(this.buildSaveEncryptedProjectEncryptionSecretRequest(params));
            if (response.status === 200)
                return true;
            if (response.status == 400 && !params.allowRotation) {
                // We're not allowing rotation, so we are trying to set the first encrypted secret, but
                // one already exists.
                throw new ProjectEncryptedSecretAlreadySaved_1.ProjectEncryptedSecretAlreadySaved(params.projectId);
            }
            throw new FailedToSaveProjectEncryptedEncryptionSecret_1.FailedToSaveProjectEncryptedEncryptionSecret(params.projectId);
        });
    }
    buildSaveEncryptedProjectEncryptionSecretRequest(params) {
        return {
            path: `/api/v3/project/${params.projectId}/encrypted-encryption-secret`,
            method: 'post',
            body: {
                projectId: params.projectId,
                encryptedEncryptionSecret: params.encryptedProjectEncryptionSecret,
                allowRotation: params.allowRotation,
            },
            abortSignal: params.abortSignal,
            acceptedAuthParams: ['projectApiKey', 'projectAccessToken'],
        };
    }
    saveScheduledReport(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildSaveScheduledReportRequest(params));
        });
    }
    buildSaveScheduledReportRequest(params) {
        return {
            path: '/api/scheduled-report',
            method: 'post',
            body: {
                cronSchedule: params.cronSchedule,
                dashboardAccessToken: this.auth.getDashboardAccessToken(),
                scheduledReportId: params.scheduledReportId,
            },
            abortSignal: params.abortSignal,
        };
    }
    updateDashboard(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildUpdateDashboardRequest(params));
        });
    }
    buildUpdateDashboardRequest(params) {
        return {
            path: '/api/v2/dashboard',
            method: 'put',
            body: {
                dashboardSessionToken: params.dashboardPermission.token,
                definition: params.definition,
                meta: params.metadata || params.meta || {},
                deleted: params.deleted,
            },
            abortSignal: params.abortSignal,
        };
    }
    updateParentGlobalLibrary(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildUpdateParentGlobalLibraryRequest(params));
        });
    }
    buildUpdateParentGlobalLibraryRequest(params) {
        return {
            path: '/api/v2/parent-global-library',
            method: 'put',
            body: {
                globalLibraryId: params.globalLibraryId,
                deleted: params.deleted,
                name: params.name,
            },
            abortSignal: params.abortSignal,
        };
    }
    updateGlobalLibrary(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildUpdateGlobalLibraryRequest(params));
        });
    }
    buildUpdateGlobalLibraryRequest(params) {
        return {
            path: '/api/v2/global-library',
            method: 'put',
            body: {
                globalLibrarySessionToken: params.globalLibrarySessionToken,
                deleted: params.deleted,
                library: params.library,
            },
            abortSignal: params.abortSignal,
        };
    }
    updateProjectApiKey(params) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.execute(this.buildUpdateProjectApiKeyRequest(params));
        });
    }
    buildUpdateProjectApiKeyRequest(params) {
        return {
            path: `/api/v3/project/${params.projectId}/api-key/${params.projectApiKeyId}`,
            method: 'put',
            body: {
                disabled: params.disabled,
            },
            abortSignal: params.abortSignal,
        };
    }
    updateQueryEngineUser(params) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.execute(this.buildUpdateQueryEngineUserRequest(params));
            if (response.status === 200)
                return true;
            throw new FailedToUpdateQueryEngineUser_1.FailedToUpdateQueryEngineUser(`Failed to update query engine user. Got status ${response.status}`);
        });
    }
    buildUpdateQueryEngineUserRequest(params) {
        return {
            path: `/api/v3/project/${params.projectId}/query-engine-user`,
            method: 'put',
            body: {
                query_engine_user_id: params.queryEngineUserId,
                password: params.password,
            },
            abortSignal: params.abortSignal,
            acceptedAuthParams: ['projectApiKey', 'projectAccessToken'],
        };
    }
}
exports.VizzlyApi = VizzlyApi;
